(function(app) {

    app.provider("transactionGroupUserMemberApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    service.updateIsActive = function (userMember) {
                        return complianceHubApiGateway.put("/TransactionGroups/" +
                            userMember.TransactionGroupId +
                            "/UserMembers/" +
                            userMember.Id,
                            userMember);
                    }

                    service.updateUserMemberRoles = function (userMember) {
                        return complianceHubApiGateway.put("/TransactionGroups/" +
                            userMember.TransactionGroupId +
                            "/UserMembers/" +
                            userMember.Id +
                            "/Roles",
                            userMember);
                    }

                    service.updateUserMemberAllowedLineOfBusinessCategoryIds = function (userMember) {
                        return complianceHubApiGateway.put("/TransactionGroups/" +
                            userMember.TransactionGroupId +
                            "/UserMembers/" +
                            userMember.Id +
                            "/AllowedLineOfBusinessCategoryIds",
                            userMember);
                    }

                    service.updateUserMemberTransactionGroup = function (userMember) {
                        return complianceHubApiGateway.put("/TransactionGroups/" +
                            userMember.TransactionGroupId +
                            "/UserMembers/" +
                            userMember.Id +
                            "/TransactionGroup",
                            userMember);
                    }

                    service.addUserMember = function(userMember) {
                        return complianceHubApiGateway
                            .post("/TransactionGroups/" + userMember.TransactionGroupId + "/UserMembers", userMember);
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app); // jshint ignore:line